import { useEffect } from 'react'

// Warns before a browser navigation/reload/close while dirtyRef.current is
// truthy. Reads the ref live inside the listener rather than depending on a
// dirty boolean prop, so callers never need to re-run this effect just to
// keep the warning current with fast-changing draft state.
export default function useUnsavedChangesWarning (dirtyRef) {
  useEffect(() => {
    const warnBeforeLeaving = event => {
      if (!dirtyRef.current) return
      event.preventDefault()
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', warnBeforeLeaving)
    return () => window.removeEventListener('beforeunload', warnBeforeLeaving)
  }, [dirtyRef])
}
